import { useState, useEffect } from "react";
import { paths, API_URL } from "../config/endpoints";
import { Unit } from "../types/property";

export const useGetUnitDetails = (uid: string) => {
  const [unit, setUnit] = useState<Unit | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [updateLoading, setUpdateLoading] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string | null>(null);

  const apiUrl = `${API_URL}/${paths.guest}/${paths.properties}/${uid}`;

  useEffect(() => {
    const fetchReservationDetails = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(`${apiUrl}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch reservation details");
        }

        const data = await response.json();
        setUnit(data);
      } catch (error: any) {
        setError(
          error.message ||
            "An error occurred while fetching reservation details"
        );
      } finally {
        setLoading(false);
      }
    };

    if (uid) {
      fetchReservationDetails();
    }
  }, [uid, apiUrl]);

  const updatedUnit = async (updatedUnit: Partial<Unit>) => {
    setUpdateLoading(true);
    setUpdateError(null);

    try {
      const response = await fetch(apiUrl, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(updatedUnit),
      });

      if (!response.ok) {
        throw new Error("Failed to update reservation");
      }

      const data = await response.json();
      setUnit(data);
    } catch (error: any) {
      setUpdateError(
        error.message || "An error occurred while updating reservation"
      );
    } finally {
      setUpdateLoading(false);
    }
  };

  return {
    unit,
    loading,
    error,
    updatedUnit,
    updateLoading,
    updateError,
  };
};
